export const ADMIN_SECTIONS = [
  "payments",
  "marketing",
  "userManagement",
  "newswire",
  "newsPortal",
  "translations",
  "ilWebsite",
  "b2b",
  "product",
  "portfolio",
  "alertsManager",
  "riskFactors",
  "analystReports",
  "adminSettings",
] as const;

export type AdminSection = (typeof ADMIN_SECTIONS)[number];

export type UserPermissions = {
  [K in AdminSection]: boolean;
};

export interface SectionConfig {
  key: AdminSection;
  label: string;
  description: string;
  icon: string;
  href: string;
  hidden?: boolean;
}

export const SECTION_CONFIGS: SectionConfig[] = [
  { key: "payments", label: "Payments", description: "Manage payment transactions and billing", icon: "CreditCard", href: "/dashboard/payments" },
  { key: "marketing", label: "Marketing", description: "Marketing campaigns and analytics", icon: "Megaphone", href: "/dashboard/marketing" },
  { key: "userManagement", label: "User Management", description: "Manage client accounts and subscriptions", icon: "Users", href: "/dashboard/users" },
  { key: "newswire", label: "Newswire", description: "News distribution and management", icon: "Newspaper", href: "/dashboard/newswire" },
  { key: "newsPortal", label: "News Portal", description: "News portal content management", icon: "Globe", href: "/dashboard/news-portal" },
  { key: "translations", label: "Translations", description: "Manage translations and localization", icon: "Languages", href: "/dashboard/translations" },
  { key: "ilWebsite", label: "IL Website", description: "Israel website management", icon: "MapPin", href: "/dashboard/il-website" },
  { key: "product", label: "Products", description: "Product management and configuration", icon: "Package", href: "/dashboard/marketing/products", hidden: true },
  { key: "b2b", label: "B2B", description: "Business-to-business operations", icon: "Building2", href: "/dashboard/b2b" },
  { key: "portfolio", label: "Portfolio", description: "Portfolio management tools", icon: "Briefcase", href: "/dashboard/portfolio" },
  { key: "alertsManager", label: "Alerts Manager", description: "Manage system alerts and notifications", icon: "Bell", href: "/dashboard/alerts" },
  { key: "riskFactors", label: "Risk Factors", description: "Risk assessment and management", icon: "ShieldAlert", href: "/dashboard/risk-factors" },
  { key: "analystReports", label: "Analyst Reports", description: "Find latest analyst report PDFs by ticker and firm", icon: "FileSearch", href: "/dashboard/analyst-reports" },
  { key: "adminSettings", label: "Admin Settings", description: "Manage admin panel users and permissions", icon: "Settings", href: "/dashboard/admin-settings" },
];

export function getSectionConfig(key: AdminSection): SectionConfig | undefined {
  return SECTION_CONFIGS.find((s) => s.key === key);
}

export function createDefaultPermissions(): UserPermissions {
  return ADMIN_SECTIONS.reduce((acc, section) => {
    acc[section] = false;
    return acc;
  }, {} as UserPermissions);
}

export function createAdminPermissions(): UserPermissions {
  return ADMIN_SECTIONS.reduce((acc, section) => {
    acc[section] = true;
    return acc;
  }, {} as UserPermissions);
}
